export const translations = {
  en: {
    nav: {
      home: "Home",
      projects: "Projects",
      contact: "Contact",
    },
    hero: {
      intro: "Hi, my name is",
      role: "I’m a web developer.",
      tagline: "I create immersive digital experiences.",
      cta: "View Projects",
    },
  },

  "pt-br": {
    nav: {
      home: "Início",
      projects: "Projetos",
      contact: "Contato",
    },
    hero: {
      intro: "Oi, meu nome é",
      role: "Sou desenvolvedora web.",
      tagline: "Crio experiências digitais imersivas.",
      cta: "Ver Projetos",
    },
  },
};
